module.exports = __webpack_public_path__ + "img/main_pic.e345cb94.svg";